import React, { Fragment, useEffect, useState } from "react";
import { Progress, Drawer, Flex } from "antd";

import "@/styles/components/dashboard-drawer.scss";
import ButtonComponent from "@/components/button/Button";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getIsMiniDashboardOpen,
  getUserInfo,
  setIsMiniDashboardOpen,
} from "@/reducers/commonSlice";
import SwitchDashBoard from "@/components/DashboardDrawer/SwitchDashBoardCard";
import UserCard from "@/components/DashboardDrawer/UserCard";
import Resources from "@/components/resources/Resources";
import { getIsGuidePanel, setIsGuidePanel } from "@/reducers/guideSlice";
import PurchaseCard from "@/components/DashboardDrawer/PurchaseCard";
import { getStudentTasks } from "@/services/students/getStudentTasks";
import SessionCardHoc from "@/pages/guide/components/SessionCardHoc";

const DashboardDrawer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isOpen = useSelector(getIsMiniDashboardOpen);
  const isGuidePanel = useSelector(getIsGuidePanel);
  const userData = useSelector(getUserInfo);
  const isGuideRole = userData?.roles?.find((x) => x.name === "Guide");
  const [taskCompleted, setTaskCompleted] = useState({
    totalTask: 0,
    completedTask: 0,
    progress: 0,
  });
  const handleOpenFullDashboard = () => {
    dispatch(setIsMiniDashboardOpen(false));
    navigate("/dashboard");
  };
  const getTotalTask = (res) => {
    return res.filter((x) => {
      return x.userId !== (x.assignedBy.id || x.assignedBy);
    });
  };

  const fetchData = () => {
    getStudentTasks()
      .then(async (res) => {
        const filteredResponse = getTotalTask(res);
        const totalTask = filteredResponse.length ?? 0;
        const totalTaskCompleted = filteredResponse.filter((x) => x.completedAt).length ?? 0;
        // const taskIds = res?.map((x) => x.taskId);
        // const taskResponse = await getTaskById(taskIds);
        const pendingTasks = filteredResponse.filter((x) => !x.completedAt);

        const taskTitleMap = filteredResponse.reduce((acc, task) => {
          acc[task.taskId] = task.title;
          return acc;
        }, {});

        console.log(pendingTasks, res, taskTitleMap);
        // Get the titles of the pending tasks by matching task IDs
        const pendingTaskTitles = pendingTasks.map((task) => taskTitleMap[task.taskId]);

        setTaskCompleted({
          totalTask: totalTask,
          completedTask: totalTaskCompleted,
          progress: Math.ceil(totalTask ? (totalTaskCompleted / totalTask) * 100 : 0),
          taskTitle: pendingTaskTitles,
        });
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    if (isOpen) {
      fetchData();
    }
  }, [isOpen]);

  const handleSwitchToGuidePanel = () => {
    dispatch(setIsGuidePanel(!isGuidePanel));
    dispatch(setIsMiniDashboardOpen(false));
    navigate("/dashboard");
  };

  // prevent scroll on body when drawer is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  return (
    <Fragment>
      <Drawer closeIcon={false} open={isOpen} keyboard={false} maskClosable={false} width={700}>
        <div className="drawer-dashboard">
          <UserCard />
          {!userData?.verified?.email ? (
            <p
              style={{
                color: "red",
                fontSize: "16px",
                fontWeight: "bold",
                margin: "10px 0",
              }}
            >
              ⚠️ Your email is not verified. Please{" "}
              <Link
                to="/profile/basic-contact-information"
                style={{
                  color: "red",
                  textDecoration: "underline",
                  fontWeight: "bold",
                }}
              >
                verify your email
              </Link>
              .
            </p>
          ) : null}
          {!isGuidePanel && isGuideRole && isGuideRole.isApproved ? <SwitchDashBoard /> : <></>}
          {isGuidePanel ? <SessionCardHoc isDrawer /> : <></>}
          <div className="resources">
            <div className="resources-section">
              <div className="heading body-b3">My Resources</div>
            </div>
            <div className="resources-buttons">
              <Resources isDrawer />
              {/* <Row gutter={[16, 16]}>
                <Col xxl={12} xl={12} lg={12} md={6} sm={24} xs={24}>
                  <ButtonComponent
                    label="Conversations"
                    varient="dark"
                    iconRight={false}
                    onClick={() => handleNavigate("/dashboard/conversations")}
                  >
                    <IconChat color="#fdfefe" />
                  </ButtonComponent>
                </Col>
                <Col xxl={12} xl={12} lg={12} md={6} sm={24} xs={24}>
                  <ButtonComponent
                    label="Tasks"
                    varient="dark"
                    iconRight={false}
                    onClick={() => handleNavigate("/dashboard/tasks")}
                  >
                    <IconSopTask color="#fdfefe" />
                  </ButtonComponent>
                </Col>
                <Col xxl={12} xl={12} lg={12} md={6} sm={24} xs={24}>
                  <ButtonComponent
                    label="Documents"
                    varient="dark"
                    iconRight={false}
                    onClick={() => handleNavigate("/dashboard/documents")}
                  >
                    <IconDocs color="#fdfefe" />
                  </ButtonComponent>
                </Col>
                <Col xxl={12} xl={12} lg={12} md={6} sm={24} xs={24}>
                  <ButtonComponent
                    label="Saved Video"
                    varient="dark"
                    iconRight={false}
                    className="button-disable"
                  >
                    <IconSaveVideo color="#fdfefe" />
                  </ButtonComponent>
                </Col>
                <Col xxl={12} xl={12} lg={12} md={6} sm={24} xs={24}>
                  <ButtonComponent
                    label="Blogs"
                    varient="dark"
                    iconRight={false}
                    disabled={true}
                    className="button-disable"
                  >
                    <IconBlog color="#fdfefe" />
                  </ButtonComponent>
                </Col>
              </Row> */}
            </div>
          </div>

          {!isGuidePanel ? (
            <div className="task-progress">
              <div className="progress-section">
                <div className="heading body-b3">My Tasks Progress</div>
              </div>
              <div className="progress-details">
                <div className="body-b4">
                  In progress task: ({taskCompleted.totalTask - taskCompleted.completedTask}/
                  {taskCompleted.totalTask})
                </div>

                <Flex align="center" gap="0.5rem">
                  <Progress
                    percent={taskCompleted.progress}
                    showInfo={false}
                    strokeColor="#262321"
                    strokeWidth={14}
                    style={{ width: "90%" }}
                  />
                  <span className="body-b2">{taskCompleted.progress}%</span>
                </Flex>

                {taskCompleted.progress === 100 ? (
                  <div style={{ color: "green" }}>All tasks completed.</div>
                ) : (
                  <div className="task-chips">
                    {taskCompleted?.taskTitle?.map((x, i) => {
                      return (
                        <div className="chip body-b4" key={i}>
                          {x}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          ) : (
            <></>
          )}

          {!isGuidePanel ? (
            <div className="purchase">
              <div className="purchase-section">
                <div className="heading body-b3">My Purchase</div>
              </div>

              <PurchaseCard />
            </div>
          ) : (
            <></>
          )}
          <div className="navigate-dashboard">
            <ButtonComponent
              varient="primary"
              label="View Full Dashboard"
              onClick={handleOpenFullDashboard}
            />
          </div>
          {isGuidePanel ? (
            <div className="navigate-dashboard">
              <ButtonComponent
                varient="primary"
                label="Switch to Student dashboard"
                onClick={handleSwitchToGuidePanel}
              />
            </div>
          ) : (
            <></>
          )}
        </div>
      </Drawer>
    </Fragment>
  );
};

export default DashboardDrawer;
